import breadcrumbsMeta from "@/graphql/breadcrumbsMeta/defaultCache";

export default {
	breadcrumbsMeta
};



// WEBPACK FOOTER //
// ./src/graphql/defaultCache.js